<template>
  <div
    id="layout"
    class="LayoutPublic h-svh w-full flex flex-col mx-auto bg-capino-light overflow-auto"
  >
    <LandingHeader />

    <router-view />

    <LandingFooter />
  </div>
</template>

<script>
import LandingHeader from '@/components/Landing/LandingHeader.vue'
import LandingFooter from '@/components/Landing/LandingFooter.vue'

export default {
  name: 'LayoutPublic',

  components: { LandingHeader, LandingFooter }
}
</script>
